<ng-content />

@if (open()) {
  <div
    #card
    class="hover-card"
    data-testid="hover-card"
    [class.is-above]="position()?.above"
    [style.top.px]="position()?.top ?? 0"
    [style.left.px]="position()?.left ?? 0"
    [style.max-height.px]="position()?.maxHeight ?? null"
    [style.visibility]="position() ? null : 'hidden'"
  >
    <ng-container *ngTemplateOutlet="content().template" />
  </div>
}
